import { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

type Footer = PropsWithChildren<HTMLAttributes<HTMLDivElement>> & {
  children: ReactNode;
};

export function Footer({ children, className, ...rest }: Footer) {
  return (
    <div className={`p-4 border-t ${className || ''}`} {...rest}>
      {children}
    </div>
  );
}
